import React from "react";
import { Table, Tag, Button, Tooltip, Icon } from "antd";
import moment from "moment";
import { toBRL } from "~/components/UI/InputCurrency";

var Column = Table.Column;

var TableList = function(props) {
    var data = props.data;
    var isLoading = props.isLoading;
    var canEdit = props.canEdit;
    var onEdit = props.onEdit;
    var onDelete = props.onDelete;
    var onMarkAsReceived = props.onMarkAsReceived;

    var getStatusTag = function(record) {
        if (record.status === 'paid') return React.createElement(Tag, { color: 'green' }, 'Recebido');
        if (record.status === 'cancelled') return React.createElement(Tag, { color: 'default' }, 'Cancelado');
        var isOverdue = moment(record.due_at).isBefore(moment(), 'day');
        if (isOverdue) return React.createElement(Tag, { color: 'red' }, 'Vencida');
        return React.createElement(Tag, { color: 'orange' }, 'Pendente');
    };

    return (
        <div className="table-clabs">
            <Table
                rowKey="id"
                dataSource={data}
                loading={isLoading}
                bordered
                size="middle"
                scroll={{ x: 1100 }}
                pagination={{ defaultPageSize: 20, showSizeChanger: true, pageSizeOptions: ['10', '20', '50', '100'] }}
            >
                <Column title="Origem" dataIndex="source" key="source" width={110} align="center"
                    render={function(source) {
                        if (source === 'mensalidade') return React.createElement(Tag, { color: 'blue' }, 'Mensalidade');
                        if (source === 'extra') return React.createElement(Tag, { color: 'purple' }, 'Extra');
                        return React.createElement(Tag, { color: 'cyan' }, 'Manual');
                    }}
                    filters={[
                        { text: 'Manual', value: 'manual' },
                        { text: 'Mensalidade', value: 'mensalidade' },
                        { text: 'Extra', value: 'extra' },
                    ]}
                    onFilter={function(value, record) { return record.source === value; }}
                />
                <Column title="Descricao" dataIndex="description" key="description" ellipsis width={300}
                    sorter={function(a, b) { return (a.description || '').localeCompare(b.description || ''); }}
                />
                <Column title="Cliente" dataIndex="customer" key="customer" width={180} ellipsis
                    render={function(customer) { return customer ? customer.name : React.createElement('span', { style: { color: '#bfbfbf' } }, '-'); }}
                />
                <Column title="Categoria" dataIndex="category" key="category" width={150}
                    render={function(cat) { return cat ? cat.value : React.createElement('span', { style: { color: '#bfbfbf' } }, '-'); }}
                />
                <Column title="Vencimento" dataIndex="due_at" key="due_at" width={120} align="center"
                    sorter={function(a, b) { return (a.due_at || '').localeCompare(b.due_at || ''); }}
                    defaultSortOrder="ascend"
                    render={function(val) { return val ? moment(val).format('DD/MM/YYYY') : '-'; }}
                />
                <Column title="Valor" dataIndex="amount" key="amount" width={130} align="right"
                    sorter={function(a, b) { return (a.amount || 0) - (b.amount || 0); }}
                    render={function(val) { return React.createElement('span', { style: { fontWeight: 600, color: '#52c41a' } }, 'R$ ' + toBRL(val || 0)); }}
                />
                <Column title="Status" key="status" width={100} align="center"
                    render={function(_, record) { return getStatusTag(record); }}
                />
                <Column title="Recebido em" dataIndex="paid_at" key="paid_at" width={120} align="center"
                    render={function(val) { return val ? moment(val).format('DD/MM/YYYY') : React.createElement('span', { style: { color: '#bfbfbf' } }, '-'); }}
                />
                <Column title="" key="actions" width={120} align="center"
                    render={function(_, record) {
                        if (record.source !== 'manual') return null;
                        return React.createElement('div', { style: { display: 'flex', gap: 4, justifyContent: 'center' } },
                            record.status === 'pending' && React.createElement(Tooltip, { title: 'Marcar como recebido' },
                                React.createElement(Button, { size: 'small', icon: 'check', type: 'primary', style: { borderRadius: 4 }, onClick: function() { onMarkAsReceived(record); } })
                            ),
                            React.createElement(Tooltip, { title: 'Editar' },
                                React.createElement(Button, { size: 'small', icon: 'edit', style: { borderRadius: 4 }, onClick: function() { onEdit(record); } })
                            ),
                            React.createElement(Tooltip, { title: 'Excluir' },
                                React.createElement(Button, { size: 'small', icon: 'delete', type: 'danger', style: { borderRadius: 4 }, onClick: function() { onDelete(record); } })
                            )
                        );
                    }}
                />
            </Table>
        </div>
    );
};

export default TableList;
